"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = connectRte;

var _generalStore = require("general-store");

var _makeOwnersTokenDependency = _interopRequireDefault(require("crm_data/tokens/makeOwnersTokenDependency"));

var FormatOwnerName = _interopRequireWildcard(require("customer-data-objects/owners/FormatOwnerName"));

function connectRte(RteComponent) {
  return (0, _generalStore.connect)({
    owners: (0, _makeOwnersTokenDependency.default)(FormatOwnerName)
  })(RteComponent);
}

module.exports = exports.default;